export const translation = {
  projectName: "MPS ARCHONIC",

  header: {
    navigation: {
      default: [],
      admin: [
        {
          name: "Projekte",
          link: "/dashboard/files",
        },
      ],
      isLoggedIn: {
        name: "Abmelden",
      },
    },
  },

  cube: {
    rotate: "Dreh mit dem Finger den Cube",
    rotateDesktop: "Dreh mit der Maus den Cube",
  },

  backToCube: {
    cta: "Zurück zum Cube",
  },

  login: {
    headline: "Anmelden",
    cta: "Anmelden",
    error: "Anmeldung fehlgeschlagen. Falsche E-Mail oder Passwort.",
  },

  footer: {
    links: "Links",
    legalLinks: [
      { name: "Impressum", link: "https://www.mps-archonic.com/impressum/" },
      {
        name: "Datenschutz",
        link: "https://www.mps-archonic.com/datenschutz/",
      },
      { name: "Kontakt", link: "https://www.mps-archonic.com/kontakt/" },
    ],
  },

  generic: {
    company: {
      name: "MPS ARCHONIC",
    },
    settings: "Einstellungen",
    hourPrefix: "Stunden: ",
    hourSuffix: " Stunden",
    squareMeterSuffix: " m²",
    equals: " = ",
    timestampPrefix: "Erstellt am: ",
    phonePrefix: "Telefon: ",
    mailPrefix: "E-Mail: ",
    websitePrefix: "Webseite: ",
    employeeSuffix: " Mitarbeiter",
    salutation: "Anrede",
    name: "Name",
    firstname: "Vorname",
    lastname: "Nachname",
    birthday: "Geburtsdatum",
    personType: "Art",
    personTypePlaceholder: "Beirat, Geschäftsführer, ...",
    street: "Straße, Hausnummer",
    companyName: "Firmenname",
    club: "Verein (optional)",
    city: "PLZ, Ort",
    mail: "E-Mail-Adresse",
    identifier: "E-Mail-Adresse",
    message: "Ihre Anfrage...",
    phone: "Telefonnummer",
    password: "Passwort",
    passwordRepeat: "Passwort wiederholen",
    createdOn: "Erstellt am",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
    close: "Schließen",
    send: "Senden",
    error:
      "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.",
    acceptAGB: "Ich akzeptiere die AGB",
    percent: " %",
    kilometerSuffix: " km",
    upload: "Hochladen",
    login: "Anmelden",
    logout: "Abmelden",
    export: "Export",
    import: "Import",
    save: "Speichern",
  },

  UI: {
    removeConfirmation: {
      title: "Bestätigung",
      text: (itemName: string) => `Möchten Sie "${itemName}" wirklich löschen?`,
    },
    copyConfirmation: {
      title: "Kopieren",
      text: (itemName: string) => `${itemName}-Kopie umbenennen zu:`,
      initNameSuffix: "-Kopie",
    },
    customerSelector: {
      label: "Kundenauswahl",
    },
    projectSelector: {
      label: "Projekt wählen",
    },
    simpleList: {
      search: "Suche",
      resultAmountSuffixPlural: " Ergebnisse",
      resultAmountSuffixSingular: " Ergebnis",
      noData: "Keine Daten vorhanden",
    },
    multiList: {
      search: "Suche",
      resultAmountSuffix: " Ergebnisse",
      noData: "Keine Daten vorhanden",
      cta: "Ausführen",
      cancelCTA: "Abbrechen",
      option: {
        EXPORT: "Export",
        PROCESS: "Verarbeiten",
        STOP: "Stoppen",
      },
      export: {
        title: "Export",
        identifier: "Kennung",
      },
      error: "Aktion konnte nicht ausgeführt werden",
    },
    csvImport: {
      title: "Import",
      startCTA: "Import starten",
      loading: "Daten werden imporiert...",
      error: "Der Import ist fehlgeschlagen.",
    },
    dropdown: {
      emptySelection: "Bitte wählen",
      search: "Suche",
    },
    selectableTagList: {
      showMore: "Mehr anzeigen",
      showLess: "Weniger",
    },
    textarea: {
      max: {
        prefix: "maximal ",
        suffix: " Zeichen",
      },
    },
    dnd: {
      text: "Bewerbung anhängen",
      hint: "(Erlaubt ist eine PDF-Datei bis zu 25 MB)",
      selectedPrefix: "Gewählte PDF: ",
      error: {
        size: "Maximale Dateigröße überschritten",
      },
    },
  },

  resetPassword: {
    passwordsDontMatch: "Passwörter stimmen nicht überein",
    passwordReset: "Passwort wurde erfolgreich geändert",
    save: "Ändern",
    password: "Passwort",
    passwordRepeat: "Passwort wiederholen",
    title: "Passwort ändern",
  },
};

export const langKey = "DE";
